// File: frontend/src/components/auth/SignOutModal.js

import React, { useState, useEffect } from 'react';
import { createPortal } from 'react-dom';
import { useAuth } from '../../hooks/useAuth';
import { useLanguage } from '../../contexts/LanguageContext';
import styles from './SignOutModal.module.css';

const SignOutModal = ({ isOpen, onClose }) => {
  const { logout } = useAuth();
  const { t } = useLanguage();
  const [isLoading, setIsLoading] = useState(false);

  // Lock body scroll when modal is open
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }

    return () => {
      document.body.style.overflow = '';
    };
  }, [isOpen]);

  if (!isOpen) return null;

  const handleBackdropClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  const handleSignOut = async () => {
    setIsLoading(true);
    try {
      await logout();
      onClose();
    } catch (error) {
      console.error('Sign out error:', error);
    } finally {
      setIsLoading(false);
    }
  };

  return createPortal(
    <div className={styles.modalBackdrop} onClick={handleBackdropClick}>
      <div className={styles.modalContainer} onClick={(e) => e.stopPropagation()}>
        <div className={styles.modalHeader}>
          <h2 className={styles.title}>
            {t('auth.signout.title', 'Sign Out')}
          </h2>
          <p className={styles.message}>
            {t('auth.signout.confirmation', 'Are you sure you want to sign out?')}
          </p>
        </div>

        <div className={styles.modalFooter}>
          <button
            onClick={onClose}
            className={styles.cancelButton}
            disabled={isLoading}
          >
            {t('auth.signout.cancel_button', 'Cancel')}
          </button>
          <button
            onClick={handleSignOut}
            className={styles.signOutButton}
            disabled={isLoading}
          >
            {isLoading 
              ? t('auth.signout.signing_out', 'Signing Out...') 
              : t('auth.signout.signout_button', 'Sign Out')
            }
          </button>
        </div>
      </div>
    </div>,
    document.body
  );
};

export default SignOutModal;